import { ParameterContainer, ParameterDefinition, ParameterValue } from '@barthauer/abc/queries/parameters/core';

export class NamedItem {
  Name: string;
  Caption: string;
}

export class NavigationDocument implements ParameterContainer {
  Groups: NavigationGroup[];
  ParameterDefinitions: ParameterDefinition[];
  Parameters: ParameterValue[];

  constructor(data: any) {
    Object.assign(this, data);
    this.Groups = new Array<NavigationGroup>();

    if (Array.isArray(data?.Groups)) {
      let index = 0;
      for (let i = 0; i < data.Groups.length; i++) {
        const group = data.Groups[i];
        if (group.IsVisible ?? true) {
          group.VisibleIndex = index++;
          group.IsVisible = true;
        } else {
          group.VisibleIndex = -1;
        }
        this.Groups.push(new NavigationGroup(group));
      }
    }

    this.ParameterDefinitions = new Array<ParameterDefinition>();
    if (Array.isArray(data?.ParameterDefinitions)) {
      for (const p of data.ParameterDefinitions) {
        this.ParameterDefinitions.push(p);
      }
    }

    this.Parameters = new Array<ParameterValue>();
    if (Array.isArray(data?.Parameters)) {
      for (const p of data.Parameters) {
        this.Parameters.push(p);
      }
    }
  }
}

export class NavigationNodeBase extends NamedItem {
  ImageUrl: string;
  VisibleIndex?: number;
  // Component to load on node click
  Component?: string;
  // Identifier for configuration in profile
  CommandIdentifier?: string;
  // The node that should be selected first
  Selected?: boolean;
  IsVisible?: boolean;
  HasDataForm?: boolean;
  MarkerTag?: string;
  Nodes: NavigationNodeBase[];
  Command?: Command;

  get isGroupOnlyNode(): boolean {
    if (this instanceof NavigationNode && this.Layout) {
      return false;
    } else {
      for (const n of this.Nodes) {
        if (!n.isGroupOnlyNode) {
          return false;
        }
      }
      return true;
    }
  }

  constructor(data: any) {
    super();
    Object.assign(this, data);

    this.Nodes = [];
    if (Array.isArray(data.Nodes)) {
      for (let node of data.Nodes) {
        if (node.Layout) {
          this.Nodes.push(new NavigationNode(node));
        } else {
          this.Nodes.push(new NavigationGroup(node));
        }
      }
    }
  }
}

export class NavigationGroup extends NavigationNodeBase {
  constructor(data: any) {
    super(data);
  }
}

export class NavigationNode extends NavigationNodeBase {
  Layout: NavigationLayout;
  Filter: string;

  constructor(data: any) {
    super(data);
    if (data.Layout) {
      this.Layout = new NavigationLayout(data.Layout);
    }
  }
}

export class NavigationLayout extends NamedItem {
  ObjectType: string;

  constructor(data: any) {
    super();
    Object.assign(this, data);
  }
}

export class Command {
  Identifier: string;
}
